import React, { useState } from "react";
import "./index.css";

const AgentPasswordResetOverlay = ({ isOpen, onClose, onPasswordReset, markentAgentDataCopy }) => {
  const [formData, setFormData] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState({
    new: false,
    confirm: false,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validatePassword = (password) => {
    const validations = {
      length: password.length >= 10,
      hasNumber: /\d/.test(password),
      hasCapital: /[A-Z]/.test(password),
    };
    return validations;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear errors when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    const validation = validatePassword(formData.newPassword);

    if (!formData.newPassword) {
      newErrors.newPassword = "Password is required";
    } else if (!validation.length) {
      newErrors.newPassword = "Password must be at least 10 characters";
    } else if (!validation.hasNumber) {
      newErrors.newPassword = "Password must contain at least one number";
    } else if (!validation.hasCapital) {
      newErrors.newPassword = "Password must contain at least one capital letter";
    }

    if (!formData.confirmPassword) {
      newErrors.confirmPassword = "Please confirm your password";
    } else if (formData.newPassword !== formData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setIsSubmitting(true);

    /* const storedAgent = localStorage.getItem("agentData");
    console.log("Stored agent data:", storedAgent); */
    console.log("markentAgentDataCopy:", markentAgentDataCopy);

    if (!markentAgentDataCopy) {
      alert("Session expired. Please sign in again.");
      setIsSubmitting(false);
      // window.location.href = "/sign-in";
      return;
    }
    let agentID = markentAgentDataCopy._id;
    let updatePasswordUrl = process.env.REACT_APP_Back_end_api_root + "/marketingAgentApp/updatePassword/" + agentID;

    try {
      let response = await fetch(updatePasswordUrl, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ newAgentPassword: formData.newPassword }),
      });
      if (!response.ok) {
        throw new Error("Failed to update password");
      }

      setFormData({ newPassword: "", confirmPassword: "" });
      alert("Password updated successfully. you will be redirected to your dashboard.");

      await onPasswordReset();
      // Reset form on success
    } catch (error) {
      setErrors({ submit: "Failed to reset password. Please try again." });
    } finally {
      setIsSubmitting(false);
    }
  };

  const validation = validatePassword(formData.newPassword);

  if (!isOpen) return null;

  return (
    <div className='sl-agent-password-reset-overlay'>
      <div className='sl-agent-password-reset-backdrop' onClick={onClose}></div>

      <div className='sl-agent-password-reset-card'>
        <div className='sl-agent-password-reset-header'>
          <div className='sl-agent-password-reset-icon'>
            <svg width='48' height='48' viewBox='0 0 24 24' fill='none'>
              <path
                d='M12 2C9.243 2 7 4.243 7 7v3H6c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-8c0-1.103-.897-2-2-2h-1V7c0-2.757-2.243-5-5-5zM9 7c0-1.654 1.346-3 3-3s3 1.346 3 3v3H9V7z'
                fill='#6366F1'
              />
            </svg>
          </div>
          <h2 className='sl-agent-password-reset-title'>Set New Password</h2>
          <p className='sl-agent-password-reset-subtitle'>Your account has a temporary password. Please create a new secure password to continue.</p>
        </div>

        <form onSubmit={handleSubmit} className='sl-agent-password-reset-form'>
          <div className='sl-agent-password-reset-field'>
            <label className='sl-agent-password-reset-label'>New Password</label>
            <div className='sl-agent-password-reset-input-wrapper'>
              <input
                type={showPassword.new ? "text" : "password"}
                name='newPassword'
                value={formData.newPassword}
                onChange={handleInputChange}
                className={`sl-agent-password-reset-input ${errors.newPassword ? "sl-agent-password-reset-input-error" : ""}`}
                placeholder='Enter new password'
              />
              <button type='button' className='sl-agent-password-reset-toggle' onClick={() => setShowPassword((prev) => ({ ...prev, new: !prev.new }))}>
                {showPassword.new ? (
                  <svg width='20' height='20' viewBox='0 0 24 24' fill='none'>
                    <path
                      d='M12 19c.946 0 1.81-.103 2.598-.281l-1.757-1.757C12.568 16.983 12.291 17 12 17c-5.351 0-7.424-3.846-7.926-5 .204-.47.674-1.381 1.508-2.297L4.184 8.305c-1.538 1.667-2.121 3.346-2.132 3.379a.994.994 0 0 0 0 .633C2.073 12.383 4.367 19 12 19zm0-14c-1.837 0-3.346.396-4.604.981L3.707 2.293 2.293 3.707l18 18 1.414-1.414-3.319-3.319c2.614-1.951 3.547-4.615 3.561-4.657a.994.994 0 0 0 0-.633C21.927 11.617 19.633 5 12 5z'
                      fill='currentColor'
                    />
                  </svg>
                ) : (
                  <svg width='20' height='20' viewBox='0 0 24 24' fill='none'>
                    <path
                      d='M12 5c-7.633 0-9.927 6.617-9.948 6.684L1.946 12l.105.316C2.073 12.383 4.367 19 12 19s9.927-6.617 9.948-6.684l.106-.316-.105-.316C21.927 11.617 19.633 5 12 5zm0 11c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z'
                      fill='currentColor'
                    />
                    <path d='M12 10c-1.084 0-2 .916-2 2s.916 2 2 2 2-.916 2-2-.916-2-2-2z' fill='currentColor' />
                  </svg>
                )}
              </button>
            </div>
            {errors.newPassword && <span className='sl-agent-password-reset-error'>{errors.newPassword}</span>}
          </div>

          {formData.newPassword && (
            <div className='sl-agent-password-reset-requirements'>
              <div className={`sl-agent-password-reset-req ${validation.length ? "sl-agent-password-reset-req-met" : ""}`}>
                <svg width='16' height='16' viewBox='0 0 24 24' fill='none'>
                  <path d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' fill='currentColor' />
                </svg>
                At least 10 characters
              </div>
              <div className={`sl-agent-password-reset-req ${validation.hasNumber ? "sl-agent-password-reset-req-met" : ""}`}>
                <svg width='16' height='16' viewBox='0 0 24 24' fill='none'>
                  <path d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' fill='currentColor' />
                </svg>
                Contains a number
              </div>
              <div className={`sl-agent-password-reset-req ${validation.hasCapital ? "sl-agent-password-reset-req-met" : ""}`}>
                <svg width='16' height='16' viewBox='0 0 24 24' fill='none'>
                  <path d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' fill='currentColor' />
                </svg>
                Contains a capital letter
              </div>
            </div>
          )}

          <div className='sl-agent-password-reset-field'>
            <label className='sl-agent-password-reset-label'>Confirm Password</label>
            <div className='sl-agent-password-reset-input-wrapper'>
              <input
                type={showPassword.confirm ? "text" : "password"}
                name='confirmPassword'
                value={formData.confirmPassword}
                onChange={handleInputChange}
                className={`sl-agent-password-reset-input ${errors.confirmPassword ? "sl-agent-password-reset-input-error" : ""}`}
                placeholder='Confirm new password'
              />
              <button type='button' className='sl-agent-password-reset-toggle' onClick={() => setShowPassword((prev) => ({ ...prev, confirm: !prev.confirm }))}>
                {showPassword.confirm ? (
                  <svg width='20' height='20' viewBox='0 0 24 24' fill='none'>
                    <path
                      d='M12 19c.946 0 1.81-.103 2.598-.281l-1.757-1.757C12.568 16.983 12.291 17 12 17c-5.351 0-7.424-3.846-7.926-5 .204-.47.674-1.381 1.508-2.297L4.184 8.305c-1.538 1.667-2.121 3.346-2.132 3.379a.994.994 0 0 0 0 .633C2.073 12.383 4.367 19 12 19zm0-14c-1.837 0-3.346.396-4.604.981L3.707 2.293 2.293 3.707l18 18 1.414-1.414-3.319-3.319c2.614-1.951 3.547-4.615 3.561-4.657a.994.994 0 0 0 0-.633C21.927 11.617 19.633 5 12 5z'
                      fill='currentColor'
                    />
                  </svg>
                ) : (
                  <svg width='20' height='20' viewBox='0 0 24 24' fill='none'>
                    <path
                      d='M12 5c-7.633 0-9.927 6.617-9.948 6.684L1.946 12l.105.316C2.073 12.383 4.367 19 12 19s9.927-6.617 9.948-6.684l.106-.316-.105-.316C21.927 11.617 19.633 5 12 5zm0 11c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z'
                      fill='currentColor'
                    />
                    <path d='M12 10c-1.084 0-2 .916-2 2s.916 2 2 2 2-.916 2-2-.916-2-2-2z' fill='currentColor' />
                  </svg>
                )}
              </button>
            </div>
            {errors.confirmPassword && <span className='sl-agent-password-reset-error'>{errors.confirmPassword}</span>}
          </div>

          {errors.submit && <div className='sl-agent-password-reset-submit-error'>{errors.submit}</div>}

          <button type='submit' className='sl-agent-password-reset-submit' disabled={isSubmitting}>
            {isSubmitting ? (
              <>
                <span className='sl-agent-password-reset-spinner'></span>
                Updating Password...
              </>
            ) : (
              "Update Password"
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AgentPasswordResetOverlay;
